import React from "react";
import { useLocalStorage } from "react-use";
import { isSameDay, parseISO, startOfToday } from "date-fns";

import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

interface Item {
  id: string;
  date: string;
}

export const SHAREPOINT_DAILY_SYNC_LIMIT = 20;

export const useSharepointSync = () => {
  const userData = useAuthenticatedUser();

  const key = `sharepointSyncing_${userData.id}`;

  const [synced, setRecentItems] = useLocalStorage<Item[]>(key, []);

  const addItem = React.useCallback(
    (item: string) => {
      setRecentItems(prevState => [
        ...(prevState || []),
        {
          id: item,
          date: new Date().toISOString(),
        },
      ]);
    },
    [setRecentItems],
  );

  const recentItems = synced || [];
  const todaySync = recentItems.filter(item => isSameDay(parseISO(item.date), startOfToday()));
  const canSync = todaySync.length < SHAREPOINT_DAILY_SYNC_LIMIT;

  return { recentItems, addRecentItem: addItem, canSync };
};
